/**
 * User Activity "type" filter options.
 * `requiredPermissions` gates each option by the tenant role (already plan-scoped).
 * Empty value = All (always shown).
 */
export const USER_ACTIVITY_TYPE_OPTIONS = [
  { labelKey: "All", value: "" },
  {
    labelKey: "Category",
    value: "category",
    requiredPermissions: [{ categoryId: 4, permissionId: "menus_1" }],
  },
  {
    labelKey: "Item",
    value: "item",
    requiredPermissions: [{ categoryId: 4, permissionId: "menus_1" }],
  },
  {
    labelKey: "Modifier Group",
    value: "modifierGroup",
    requiredPermissions: [
      {
        categoryId: 4,
        permissionId: "menus_1",
        subPermissionId: "modifier_access_view",
      },
    ],
  },
  {
    labelKey: "Modifier Customization",
    value: "modifierCustomization",
    requiredPermissions: [
      {
        categoryId: 4,
        permissionId: "menus_1",
        subPermissionId: "modifier_access_view",
      },
    ],
  },
  {
    labelKey: "Item Group",
    value: "itemGroup",
    requiredPermissions: [
      {
        categoryId: 4,
        permissionId: "menus_1",
        subPermissionId: "combo_access_view",
      },
    ],
  },
  {
    labelKey: "Menu Setup",
    value: "menuSetup",
    requiredPermissions: [{ categoryId: 4, permissionId: "menus_1" }],
  },
  {
    labelKey: "Menu",
    value: "menu",
    requiredPermissions: [{ categoryId: 4, permissionId: "menus_1" }],
  },
  {
    labelKey: "Item Tag",
    value: "itemTag",
    requiredPermissions: [{ categoryId: 4, permissionId: "item_tag_1" }],
  },
  {
    labelKey: "Ingredient",
    value: "ingredient",
    requiredPermissions: [{ categoryId: 23, permissionId: "ingredient_1" }],
  },
  {
    labelKey: "Allergen",
    value: "allergen",
    requiredPermissions: [{ categoryId: 24, permissionId: "allergen_1" }],
  },
  {
    labelKey: "Branch",
    value: "branch",
    requiredPermissions: [
      { categoryId: 5, permissionId: "branchLocations_1" },
    ],
  },
  {
    labelKey: "Zone",
    value: "zone",
    requiredPermissions: [{ categoryId: 43, permissionId: "zone_1" }],
  },
  {
    labelKey: "Region",
    value: "region",
    requiredPermissions: [{ categoryId: 25, permissionId: "region_1" }],
  },
  {
    labelKey: "City",
    value: "city",
    requiredPermissions: [{ categoryId: 26, permissionId: "city_1" }],
  },
  {
    labelKey: "Country",
    value: "country",
    requiredPermissions: [{ categoryId: 11, permissionId: "country_1" }],
  },
  {
    labelKey: "Role",
    value: "role",
    requiredPermissions: [{ categoryId: 3, permissionId: "roles_1" }],
  },
  {
    labelKey: "User",
    value: "user",
    requiredPermissions: [{ categoryId: 6, permissionId: "usersPermission_1" }],
  },
  {
    labelKey: "Customer",
    value: "customer",
    requiredPermissions: [
      { categoryId: 7, permissionId: "customersPermission_1" },
    ],
  },
  {
    labelKey: "Coupon",
    value: "coupon",
    requiredPermissions: [{ categoryId: 14, permissionId: "promotion_1" }],
  },
  {
    labelKey: "Coupon Group",
    value: "couponGroup",
    requiredPermissions: [{ categoryId: 14, permissionId: "promotion_1" }],
  },
  {
    labelKey: "Promotion",
    value: "promotion",
    requiredPermissions: [{ categoryId: 14, permissionId: "promotion_1" }],
  },
  {
    labelKey: "Coupon Redeem",
    value: "couponRedeem",
    requiredPermissions: [{ categoryId: 46, permissionId: "coupon_redeem_1" }],
  },
  {
    labelKey: "Push Notification",
    value: "pushNotification",
    requiredPermissions: [{ categoryId: 15, permissionId: "notification_1" }],
  },
  {
    labelKey: "Banner",
    value: "banner",
    requiredPermissions: [{ categoryId: 2, permissionId: "inAppContent_1" }],
  },
  {
    labelKey: "Offer Banner",
    value: "offerBanner",
    requiredPermissions: [{ categoryId: 49, permissionId: "offerBanner_1" }],
  },
  {
    labelKey: "Brand",
    value: "brand",
    requiredPermissions: [{ categoryId: 52, permissionId: "brands_1" }],
  },
  {
    labelKey: "Delivery Partner",
    value: "deliveryPartner",
    requiredPermissions: [
      { categoryId: 47, permissionId: "delivery_partners_1" },
    ],
  },
  {
    labelKey: "Support Issue Type",
    value: "supportIssueType",
    requiredPermissions: [
      { categoryId: 17, permissionId: "customer_support_1" },
    ],
  },
  {
    labelKey: "Ticket",
    value: "ticket",
    requiredPermissions: [
      { categoryId: 17, permissionId: "customer_support_1" },
    ],
  },
  {
    labelKey: "System Settings",
    value: "systemSettings",
    requiredPermissions: [
      { categoryId: 32, permissionId: "app_settings_1" },
      { categoryId: 19, permissionId: "referral_1" },
      { categoryId: 50, permissionId: "order_cancel_settings_1" },
    ],
  },
  {
    labelKey: "Loyalty Points",
    value: "loyalty-points",
    requiredPermissions: [{ categoryId: 20, permissionId: "loyalty_1" }],
  },
]

export const getUserActivityTypeLabel = (type, t) => {
  const option = USER_ACTIVITY_TYPE_OPTIONS.find(item => item.value === type)
  return option ? t(option.labelKey) : type
}

export default USER_ACTIVITY_TYPE_OPTIONS
